import { useCallback, useState } from 'react';

export const useAgreementCheckbox = () => {
  const [agreementCheckbox, setAgreementCheckbox] = useState(true);

  const toggleAgreementCheckbox = useCallback(() => {
    setAgreementCheckbox(prev => !prev);
  }, []);

  return {
    agreementCheckbox,
    toggleAgreementCheckbox,
  };
};
